export const DashboardBlockType = [
	{ name: "Simple", value: 0 },
	{ name: "Array", value: 1 },
	//{name : "Stats", value : 2} //plus tard

]

export const DashboardBlockTypeDropdown = [
	{
		value: 0,
		text: <span><i class="fas fa-square" style={{ color: "var(--main)", paddingRight: "25px" }}></i>  Simple </span>
	},
	{
		value: 1,
		text: <span><i class="fas fa-th" style={{ color: "var(--main)", paddingRight: "25px" }}></i> Grid </span>
	},
]